export const contentTypes = {
  ContentfulBlogPost: { label: 'Blog', url: '/blog' },
  ContentfulPlay: { label: 'Play', url: '/resources/playbooks' },
  ContentfulPageSuccessStory: { label: 'Success Story', url: '/customers' },
  ContentfulStreamEpisode: {
    label: 'Stream',
    url: '/resources/stream/series',
  },
  ContentfulPageProductUpdate: {
    label: 'Product Update',
    url: '/platform/product-updates',
  },
  ContentfulPressRelease: {
    label: 'Press Release',
    url: '/resources/press-releases',
  },
};
